import styled from 'styled-components';

export const TopItem = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #6b6767;
  height: 4rem;
`;
